<template>
  <v-row>
    <v-col>
      <div class="text-h5 font-weight-bold">{{ title }}</div>
      <v-data-iterator
        :no-data-text="noDataText"
        :items="dadosTabela"
        :items-per-page.sync="itemsPerPage"
        :page="pagePorHora"
        :search="searchTabelaHora"
        :no-results-text="noResultsText"
        hide-default-footer
      >
        <template v-slot:header>
          <v-row justify="end">
            <v-col cols="4">
              <v-text-field
                v-model="searchTabelaHora"
                clearable
                hide-details
                prepend-inner-icon="mdi-magnify"
                label="Busca"
              />
            </v-col>
          </v-row>
        </template>
        <template v-slot:default="props">
          <v-data-table
            dense
            :headers="headersHora"
            :items="props.items"
            hide-default-footer
            class="elevation-1"
            disable-pagination
            disable-sort
          />
        </template>

        <template v-slot:footer>
          <v-row class="mt-2" align="center" justify="center">
            <div class="ml-4 mb-2 grey--text">
              <p>Total de Registros: {{ dadosTabela.length }}</p>
            </div>
            <v-spacer />
            <div class="pb-5">
              <ListPagination
                :page="pagePorHora"
                :numberOfPages="numberOfPagesHora"
                @firstPage="firstPage()"
                @formerPage="formerPage()"
                @nextPage="nextPage()"
                @lastPage="lastPage()"
              />
            </div>
          </v-row>
        </template>
      </v-data-iterator>
    </v-col>
  </v-row>
</template>

<script>
import ListPagination from '@/componentes/ListPagination'

export default {
  name: 'TableDataPorHora',
  components: { ListPagination },
  props: ['dadosTabela', 'title'],
  data: () => ({
    noDataText: process.env.VUE_APP_NO_DATA_TEXT,
    noResultsText: process.env.VUE_APP_NO_RESULTS_TEXT,
    searchTabelaHora: '',
    pagePorHora: 1,
    itemsPerPage: 20,
    headersHora: [
      { text: 'Dia', value: 'data', align: 'left' },
      { text: 'Hora', value: 'hora', align: 'left' },
      { text: 'Total', value: 'total', align: 'right' },
      { text: 'Atendidas', value: 'atendidas', align: 'left' },
      { text: 'Não Atendidas', value: 'naoAtendidas', align: 'left' },
      { text: 'TMC', value: 'tmc', align: 'left' },
      { text: 'TMA', value: 'tma', align: 'left' },
      { text: 'TME', value: 'tme', align: 'left' },
    ],
    itemsHora: [],
  }),

  computed: {
    qtdRegistrosHora() {
      return this.itemsHora.length
    },
    numberOfPagesHora() {
      return Math.ceil(this.dadosTabela.length / this.itemsPerPage)
    },
  },

  methods: {
    nextPage() {
      if (this.pagePorHora + 1 <= this.numberOfPagesHora) {
        this.pagePorHora += 1
      }
    },
    formerPage() {
      if (this.pagePorHora - 1 >= 1) {
        this.pagePorHora -= 1
      }
    },
    firstPage() {
      if (this.pagePorHora > 1) {
        this.pagePorHora = 1
      }
    },
    lastPage() {
      if (this.pagePorHora < this.numberOfPagesHora) {
        this.pagePorHora = this.numberOfPagesHora
      }
    },
  },
}
</script>
